import * as types from '../../lib/actionTypes.es6';

export const initialState = {
  subscriptions: [],
  loader: false,
  errors: null,

  selectedSubscription: null,
  editLoader: false,
  editSuccess: false,
  editErrors: null,

  createLoader: false,
  createSuccess: false,
  createErrors: null,

  deleteLoader: false,
  deleteSuccess: false,
  deleteErrors: null,

  authLoader: false,
  authSuccess: false,
  authErrors: null,
};

export default function webhookSubscriptionsReducer(state = initialState, action) {
  switch (action.type) {
    case types.VIEW_ALL_WEBHOOK_SUBSCRIPTIONS_REQUEST:
      return { ...state, loader: true, errors: null };

    case types.VIEW_ALL_WEBHOOK_SUBSCRIPTIONS_SUCCESS:
      return {
        ...state,
        loader: false,
        subscriptions: action.payload,
        errors: null,
      };

    case types.VIEW_ALL_WEBHOOK_SUBSCRIPTIONS_FAILURE:
      return {
        ...state,
        loader: false,
        errors: action.payload,
      };

    case types.CREATE_WEBHOOK_SUBSCRIPTION_REQUEST:
      return {
        ...state,
        createLoader: true,
        createSuccess: false,
        createErrors: null,
      };

    case types.CREATE_WEBHOOK_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        createLoader: false,
        createSuccess: true,
        createErrors: null,
      };

    case types.CREATE_WEBHOOK_SUBSCRIPTION_FAILURE:
      return {
        ...state,
        createLoader: false,
        createSuccess: false,
        createErrors: action.payload,
      };

    case types.RESET_CREATE_WEBHOOK_SUCCESS:
      return {
        ...state,
        createSuccess: false,
        createErrors: null,
      };

    case types.RESET_CREATE_WEBHOOK_ERROR:
      return {
        ...state,
        createErrors: null,
      };

    case types.EDIT_WEBHOOK_SUBSCRIPTION_REQUEST:
      return {
        ...state,
        editLoader: true,
        editSuccess: false,
        editErrors: null,
      };

    case types.EDIT_WEBHOOK_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        editLoader: false,
        editSuccess: true,
        editErrors: null,
      };

    case types.EDIT_WEBHOOK_SUBSCRIPTION_FAILURE:
      return {
        ...state,
        editLoader: false,
        editSuccess: false,
        editErrors: action.payload,
      };

    case types.RESET_EDIT_WEBHOOK_SUCCESS:
      return {
        ...state,
        editSuccess: false,
        editErrors: null,
      };

    case types.RESET_EDIT_WEBHOOK_ERROR:
      return {
        ...state,
        editErrors: null,
      };

    case types.DELETE_WEBHOOK_SUBSCRIPTION_REQUEST:
      return {
        ...state,
        deleteLoader: true,
        deleteSuccess: false,
        deleteErrors: null,
      };

    case types.DELETE_WEBHOOK_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        deleteLoader: false,
        deleteSuccess: true,
        deleteErrors: null,
      };

    case types.DELETE_WEBHOOK_SUBSCRIPTION_FAILURE:
      return {
        ...state,
        deleteLoader: false,
        deleteSuccess: false,
        deleteErrors: action.payload,
      };

    case types.SAVE_WEBHOOK_SUBSCRIPTION_AUTH_REQUEST:
      return {
        ...state,
        authLoader: true,
        authSuccess: false,
        authErrors: null,
      };

    case types.SAVE_WEBHOOK_SUBSCRIPTION_AUTH_SUCCESS:
      return {
        ...state,
        authLoader: false,
        authSuccess: true,
        authErrors: null,
      };

    case types.SAVE_WEBHOOK_SUBSCRIPTION_AUTH_FAILURE:
      return {
        ...state,
        authLoader: false,
        authSuccess: false,
        authErrors: action.payload,
      };

    case types.DELETE_WEBHOOK_SUBSCRIPTION_AUTH_REQUEST:
      return {
        ...state,
        authLoader: true,
        authSuccess: false,
        authErrors: null,
      };

    case types.DELETE_WEBHOOK_SUBSCRIPTION_AUTH_SUCCESS:
      return {
        ...state,
        authLoader: false,
        authSuccess: true,
        authErrors: null,
      };

    case types.DELETE_WEBHOOK_SUBSCRIPTION_AUTH_FAILURE:
      return {
        ...state,
        authLoader: false,
        authSuccess: false,
        authErrors: action.payload,
      };

    case types.RESET_AUTH_WEBHOOK_SUCCESS:
      return {
        ...state,
        authSuccess: false,
        authErrors: null,
      };

    case types.RESET_AUTH_WEBHOOK_ERROR:
      return {
        ...state,
        authErrors: null,
      };

    default:
      return state;
  }
}
